import Vue from 'vue'
import App from '@/App.vue'
import router from '@/plugins/router/index.js'
import vuetify from '@/plugins/vuetify'

// TODO: FILTROS
import "animate.css"
import _ from 'lodash';
import '@/plugins/filtros';

// TODO: PLUGINS
import '@/plugins/config';
import '@/plugins/languagen';
import '@/plugins/service';

Vue.config.productionTip = true

// Importação assíncrona de controllers
const controllers = [
    'Usuario.controller.js',
    'Carrinho.controller.js',
    'Google.controller',
    'Service.controller',
    'Util.controller',
    'Storage.controller',
    'SuperIngresso.controller',
    'Sac.controller',
    'RegradeNegocio.controller'
];

// Chama o método para carregar os controllers
const loadControllers = async () => {
    for (const controller of controllers) {
        await import(`@/controllers/${controller}`);
    }
};

loadControllers().then(() => {
    new Vue({
        render: h => h(App),
        vuetify,
        router,
        data() {
            return {
                loading: false
            }
        },
        methods: {
            onCaptchaVerified(){
                console.log('onCaptchaVerified')
                this.loading = false
                window.grecaptcha.execute()

                if (this.$carrinho.resolveCaptcha) {
                    this.$carrinho.resolveCaptcha();
                    this.$carrinho.resolveCaptcha = null;
                }
            },
            onCaptchaExpired(widgetId = null){
                if (widgetId) {
                    window.grecaptcha.reset(widgetId)
                } else {
                    window.grecaptcha.reset()
                }
                console.warn('onCaptchaExpired')

                if (this.$carrinho.resolveCaptcha) {
                    this.$carrinho.resolveCaptcha();
                    this.$carrinho.resolveCaptcha = null;
                }

                const time = setInterval(() => {
                    if(window.grecaptcha){
                        clearInterval(time)
                        window.grecaptcha.execute()
                    }
                }, 1000)
            },
        }
    }).$mount('#app');
});
